<template>
    <div class="con">
        <div class="banner">
            <img src="../assets/yr/hbanner.png" alt="">
        </div>
        <div class="main">
            <p class="title">{{$t('home').text8}}</p>
            <div class="lines">
                <span></span>
                <span class="t"></span>
                <span></span>
            </div>
            <div class="mainCon">
                <viewer :images="hList" style="width:100%;display: flex;flex-direction: row;flex-wrap: wrap">
                    <div class="aItem" v-for="(item,index) in hList" :key="index">
                        <div class="a">
                            <img :src="`http://www.yourlonglighting.com/upload/${item.SMALLPIC}`" alt="">
                        </div>
                        <p>{{item.TITLE}}</p>
                    </div>
                </viewer>
            </div>
        </div>
        <foot-Component></foot-Component>
    </div>
</template>

<script>
    import footComponent from '../components/foot'
    import { getNewsUrl} from '../util/lang'
    export default {
        name: "honor",
        data(){
            return{
                hList:[]
            }
        },
        components:{footComponent},
        mounted() {
            if(this.$i18n.locale==='en'){
                this.getNews('39')
            }else{
                this.getNews('41')
            }

        },
        methods:{
            getNews(id){
                const url = `${getNewsUrl(this.$i18n.locale,id,1000,1)}`
                this.$axios.get(url).then(res => {
                    this.hList= res.data.newsArr
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.con{
    width: 100%;
    animation: down 2s linear;
    @keyframes down {
        from{
            transform: translateX(-30px);
        }
        to{
            transform: translateX(0);
        }
    }
    .banner {
        width: 100%;
        overflow: hidden;
        img {
            width: 100%;
            object-fit: cover;
            display: block;
            animation: big 1s linear forwards;
        }
        @keyframes big {
            from{
                transform: scale(1.1);
            }
            to{
                transform: scale(1);
            }
        }
    }
    .main{
        width:1280px;
        margin: 0 auto;
        padding: 30px 0;
        .title{
            text-align: center;
            font-family:Calibri;
            font-size: 25px;
            text-transform: uppercase;
            margin-block-end: 0.5em;
        }
        .lines{
            width:100%;
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            span{
                display: inline-block;
                width:12px;
                height:1px;
                background-color: rgba(0,0,0,.6);
                margin-top:5px;
            }
            .t{
                width:8px;
                background-color: rgba(0,0,0,.3);
            }
        }
        .mainCon{
            width:100%;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            margin-top: 50px;
            .aItem{
                width:20%;
                text-align: center;
                margin-left: 4%;
                margin-top: 30px;
                cursor: pointer;
                .a{
                    padding: 20px 20px;
                    overflow: hidden;
                    height:200px;
                    img{
                        width:100%;
                        height:100%;
                        object-fit: contain;
                        transition: all 2s;
                    }
                }
                p{
                    font-family: Calibri;
                    font-size: 18px;
                    line-height: 30px;
                    text-transform: uppercase;
                    transition: all 2s;
                }
            }
            .aItem:hover{
                .a{
                    img{
                        transform: scale(1.1);
                    }
                }
                p{
                    color:#F4A000;
                }
            }
        }
    }
    @media screen and (max-width:450px) {
        .banner {
            img {
                height: 300px;
            }
        }
        .main{
            width:95%;
            .mainCon{
                .aItem{
                    width:45%;
                    margin-left: 3%;
                }
            }
        }
    }
}
</style>
